import { can, canLike } from '@core/utils/useAccess'

export const typeOptions = [
  { title: '紧急', value: 'urgent' },
  { title: '普通', value: 'ordinary' },
  { title: '囤货', value: 'store_goods' },
]
export const compareOptions = [
  { label: '>', value: '大于' },
  { label: '=', value: '等于' },
  { label: '<', value: '小于' },
]
export const pointStatusOptions = [
  { title: '未开始', value: 0 },
  { title: '进行中', value: 1 },
  { title: '已完成', value: 2 },
]

export const assignStatusOptions = [
  { title: '未指派组长', value: 0 },
  { title: '已指派', value: 1 },
]

export const currentPointStatusOptions = [
  { title: '待开始', value: 0 },
  { title: '进行中', value: 1 },
  { title: '超时', value: 2 },
  { title: '已完成', value: 3 },
  { title: '超时完成', value: 4 },
  { title: '退回', value: 5 },
  { title: '待审核', value: 6 },
]

export const pointOptions = [
  { title: '文案', value: 1 },
  { title: '翻译', value: 2 },
  { title: '配音', value: 3 },
  { title: '分镜', value: 4 },
  { title: '后期', value: 5 },
]

export const pointOptions2 = [
  { title: '文案', value: 1 },
  { title: '翻译', value: 2 },
  { title: '配音', value: 3 },
  { title: '分镜', value: 4 },
  { title: '拍摄', value: 6 },
  { title: '后期', value: 5 },
]

export const workPointStatusOptions = [
  { title: '待处理', value: 0 },
  { title: '进行中', value: 1 },
  { title: '已完成', value: 2 },

  // { title: '超时未完成', value: 3 },
  // { title: '超时已完成', value: 4 },
]

export const taskStatusOptions = [
  { title: '未开始', value: 0 },
  { title: '进行中', value: 1 },
  { title: '已完成', value: 2 },
  { title: '已删除', value: 3 },
  { title: '未删除', value: 4 },
]

export const pointTypeOptions = [
  { title: '文本输入', value: 'textField' },
  { title: '多行文本输入', value: 'textArea' },
  { title: '文本选择', value: 'select' },
  { title: '单项选择', value: 'radio' },
  { title: '多项选择', value: 'checkbox' },
  { title: '富文本编辑', value: 'richText' },
  { title: '文件上传', value: 'fileInput' },
]

export const isOvertimeOptions = [
  { title: '未超时', value: 0 },
  { title: '超时', value: 1 },
]

export const channelTypeOptions = [
  { title: 'youtube', value: 'youtube' },
  { title: 'facebook', value: 'facebook' },
]

export const dayOptions = [
  { title: '首日', value: '0' },
  { title: '次日', value: '1' },
  { title: '第三日', value: '2' },
  { title: '第四日', value: '3' },
  { title: '第五日', value: '4' },
  { title: '第六日', value: '5' },
  { title: '第七日', value: '6' },
  { title: '第八日', value: '7' },
  { title: '第九日', value: '8' },
  { title: '第十日', value: '9' },
  { title: '第十一日', value: '10' },
  { title: '第十二日', value: '11' },
  { title: '第十三日', value: '12' },
  { title: '第十四日', value: '13' },
  { title: '第十五日', value: '14' },
  { title: '第十六日', value: '15' },
  { title: '第十七日', value: '16' },
  { title: '第十八日', value: '17' },
  { title: '第十九日', value: '18' },
  { title: '第二十日', value: '19' },
]

export const weekOptions = [
  { title: '周一', value: '1' },
  { title: '周二', value: '2' },
  { title: '周三', value: '3' },
  { title: '周四', value: '4' },
  { title: '周五', value: '5' },
  { title: '周六', value: '6' },
  { title: '周日', value: '7' },
]

export const pageOptions = [
  { title: '每页5个', value: 5 },
  { title: '每页10个', value: 10 },
  { title: '每页15个', value: 15 },
  { title: '每页20个', value: 20 },
]

export const priceTypeOptions = [
  { title: '配音时长单价(元/分)', value: 1 },
  { title: '配音条数单价(元/条)', value: 2 },
]

export const writingPriceTypeOptions = [
  { title: '文案单价(元/千字)', value: 3 },
]

export const laterPriceTypeOptions = [
  { title: '后期时长单价(元/分)', value: 4 },
]

export const priceTypeMacroOptions = [
  { title: '配音', value: 'dubbing' },
  { title: '文案', value: 'copywriting' },
  { title: '后期', value: 'later' },
]

export const isExamineOptions = [
  { title: '待审核', value: 0 },
  { title: '通过', value: 1 },
]

export const levelOptions = [
  { title: 'A', value: 'A' },
  { title: 'B', value: 'B' },
  { title: 'C', value: 'C' },
  { title: 'D', value: 'D' },
  { title: 'E', value: 'E' },
]

export const videoStatusOptions = [
  { title: '无', value: 'none' },
  { title: '黄标', value: 'yellow_label' },
  { title: '版权主张', value: 'copyright_claims' },
  { title: '下架', value: 'off_the_shelf' },
  { title: '弃题', value: 'abandon_the_question' },
  { title: '囤货', value: 'store_goods' },
  { title: '发布', value: 'release' },
]

export const uploadStatusOptions = [
  { title: '下载中', value: '下载中' },
  { title: '实际开始下载', value: '实际开始下载' },
  { title: '下载完成', value: '下载完成' },
  { title: '下载失败', value: '下载失败' },
  { title: '上传中', value: '上传中' },
  { title: '实际开始上传', value: '实际开始上传' },
  { title: '上传失败', value: '上传失败' },
  { title: '上传完成', value: '上传完成' },
]

export const orderStatusOptions = [
  { title: '待分配任务', value: '0' },
  { title: '进行中', value: '1' },
  { title: '批次待验收', value: '2' },
  { title: '订单待验收', value: '3' },
  { title: '已完成', value: '4' },
  { title: '超时', value: '5' },
  { title: '超时完成', value: '6' },
]

export const newWorkflowPointStatus = [
  { title: '待开始 ', value: '0' },
  { title: '进行中', value: '1' },
  { title: '超时', value: '2' },
  { title: '已完成', value: '3' },
  { title: '超时完成', value: '4' },
  { title: '退回', value: '5' },
  { title: '待审核', value: '6' },
]

export const newPriceTypeOptions = [
  { title: '元/分钟', value: 1 },
  { title: '元/条', value: 2 },
]

export const workflowStatusOptions = [
  { text: '待分配任务', value: 0 },
  { text: '进行中', value: 1 },
  { text: '待验收', value: 2 },
  { text: '视频通过', value: 3 },
  { text: '视频退回制作', value: 4 },
  { text: '视频退回运营', value: 5 },
  { text: '视频退回制作(复核中)', value: 6 },
  { text: '视频退回运营(复核中)', value: 7 },
]

export const isOrderSystemOptions = [
  { title: '老系统', value: 0 },
  { title: '订单系统', value: 1 },
]

export const departmentOptionsOri = [
  { text: '杭州原创FB', value: 0 },
  { text: '杭州原创YT中长视频', value: 1 },
  { text: '杭州原创YT短视频', value: 2 },
  { text: '总编室', value: 9 },
  { text: '制作部', value: 10 },
]

export const departmentOptionsBusiness = [
  { text: '电商事业部', value: 3 },
  { text: '制作部', value: 10 },
]

export const departmentOptionsSea = [
  { text: '商家出海事业部', value: 4 },
  { text: '制作部', value: 10 },
]

export const departmentOptionsYT = [
  { text: 'YT事业部', value: 5 },
  { text: '总编室', value: 9 },
  { text: '制作部', value: 10 },
]

export const departmentOptionsBD = [
  { text: '品牌市场部', value: 6 },
  { text: '制作部', value: 10 },
]

export const departmentOptionsCreation = [
  { text: '签约创作者', value: 7 },
  { text: '制作部', value: 10 },
]

export const departmentOptionsTK = [
  { text: 'TK事业部', value: 8 },
  { text: '制作部', value: 10 },
]

export const departmentOptionsAll = [
  { text: '杭州原创FB', value: 0 },
  { text: '杭州原创YT中长视频', value: 1 },
  { text: '杭州原创YT短视频', value: 2 },
  { text: '电商事业部', value: 3 },
  { text: '商家出海事业部', value: 4 },
  { text: 'YT事业部', value: 5 },
  { text: '品牌市场部', value: 6 },
  { text: '签约创作者', value: 7 },
  { text: 'TK事业部', value: 8 },
  { text: '总编室', value: 9 },
  { text: '制作部', value: 10 },
]

// export const departmentOptions = canLike(['电商']) ? departmentOptionsBusiness : can(['超级管理员', '总监']) ? departmentOptionsAll : canLike(['出海']) ? departmentOptionsSea : departmentOptionsOri

const options = () => {
  if (canLike(['电商'])) {
    return departmentOptionsBusiness
  }
  if (can(['超级管理员', '总监', '项目管理'])) {
    return departmentOptionsAll
  }
  if (canLike(['出海'])) {
    return departmentOptionsSea
  }
  if (canLike(['YT事业'])) {
    return departmentOptionsYT
  }
  if (canLike(['品牌市场'])) {
    return departmentOptionsBD
  }
  if (canLike(['签约创作者'])) {
    return departmentOptionsCreation
  }
  if (canLike(['TK事业部'])) {
    return departmentOptionsTK
  }

  return departmentOptionsOri
}

export const departmentOptions = options()

// console.log(departmentOptions)

export const sendRuleOperationText = sendRule => {
  if (sendRule === 0) return '发往运营系统'
  if (sendRule === 1) return '发往平台'
  if (sendRule === 2) return '不发送'

  return '空'
}

export const platformList = [
  { title: 'YouTube', value: 'YouTube' },
  { title: 'Facebook', value: 'Facebook' },
]

export const platformShow = {
  youtube: 'YouTube',
  facebook: 'Facebook',
}

// 长视频剪短视频，长视频状态
export const longCutShortStatusOptions = [
  { text: '剪辑中', value: 0 },
  { text: '下载排队', value: 1 },
  { text: '上传排队', value: 2 },
  { text: '下载失败', value: 3 },
  { text: '上传中', value: 4 },
  { text: '上传失败', value: 5 },
  { text: '上传完成', value: 6 },
]

// 长视频剪短视频，短视频状态
export const longCutShortStatusShortOptions = [
  { text: '初始状态', value: 0 },
  { text: '待剪辑', value: 1 },
  { text: '剪辑中', value: 2 },
  { text: '剪辑成功', value: 3 },
  { text: '剪辑失败', value: 4 },
  { text: '下载排队', value: 5 },
  { text: '下载失败', value: 6 },
  { text: '上传中', value: 7 },
  { text: '上传失败', value: 8 },
  { text: '上传完成', value: 9 },
]

export const sourceOptions = [
  { text: '系统合成', value: 0 },
  { text: '手动上传', value: 1 },
]
export const newPlatformList = [
  { title: 'YouTube', value: 'youtube' },
  { title: 'Facebook', value: 'facebook' },
]

// 短视频合长视频，
export const shortToLongStatusOptions = [
  { text: '待发布', value: 0 },
  { text: '发布排队', value: 2 },
  { text: '下载失败', value: 3 },
  { text: '发布中', value: 4 },
  { text: '发布成功', value: 5 },
  { text: '发布失败', value: 6 },
  { text: '下载排队', value: 7 },
  { text: '正在终止', value: 20 },
  { text: '已终止', value: 21 },
  { text: '合成中', value: 23 },
  { text: '合成失败', value: 24 },
]

export const myOrderOptions = [
  { label: '待开始', value: 1 },
  { label: '进行中', value: 2 },
  { label: '已完成', value: 4 },
]

export const platformOptions = [
  { label: 'Youtube', value: 'youtube' },
  { label: 'Facebook', value: 'facebook' },
]

export const sendPlatformTypeOptions = [
  { label: '平台', value: 1 },
  { label: '内容分发系统', value: 2 },
  { label: '不发送', value: 3 },
]
